export default __webpack_public_path__ + "static/media/Ballroll_00386.88ca4dcc.png";